(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-accessory-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ai-accessory-product')) {
  customElements.define('ai-accessory-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.s = this.config.strings;
      this.q = selector => this.querySelector(selector);
      this.variant = this.config.variants.find(v => v.id === this.config.initial);

      this.form = this.q('form');
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal: this.abort.signal});
      on(this, 'change', event => {
        if (event.target.matches('[data-filters] input')) {
          this.variant = this.config.variants.find(v => v.id === Number(event.target.value));
          this.update(true);
        }
      });
      on(this, 'click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) { event.preventDefault(); this.showImage(Number(thumb.dataset.thumb)); }
        const previous = event.target.closest('[data-gallery-prev]');
        if (previous) { event.preventDefault(); const count = this.choice.images.length; if (count > 1) this.showImage((this.imageIndex - 1 + count) % count); return; }
        const next = event.target.closest('[data-gallery-next]');
        if (next) { event.preventDefault(); const count = this.choice.images.length; if (count > 1) this.showImage((this.imageIndex + 1) % count); return; }
        if (event.target.closest('[data-zoom]')) {
          event.preventDefault();
          const img = this.choice.images[this.imageIndex || 0];
          if (img) {
            this.q('[data-large]').src = img.large;
            this.q('[data-large]').alt = img.alt;
            this.q('[data-dialog]').showModal();
          }
        }
        if (event.target.closest('[data-close]') || event.target === this.q('[data-dialog]')) this.q('[data-dialog]').close();
        if (event.target.closest('[data-shipping]')) this.q('[id^="SoundBoxShipping-"]').open = true;
        
      });
      on(this.form, 'submit', event => this.addToCart(event));
      on(window, 'popstate', () => this.readURL());

      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.q('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.observer.observe(this.q('[data-add]'));
      this.readURL();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.initialized = false; }
    readURL() {
      const url = new URL(location.href);
      this.variant = this.config.variants.find(v => String(v.id) === url.searchParams.get('variant')) || this.config.variants.find(v => v.id === this.config.initial);
      this.querySelectorAll('[data-filters] input').forEach(el => el.checked = Number(el.value) === this.variant.id);
      this.update(false);
    }
    update(writeURL) {
      this.choice = this.variant;
      this.q('[data-price]').textContent = this.choice.price;
      this.q('[data-variant-id]').value = this.choice.id;
      this.querySelectorAll('[data-filters] input').forEach(el => el.checked = Number(el.value) === this.variant.id);
      this.q('[data-sticky-title]').textContent = this.config.productName + (this.variant.title === 'Default Title' ? '' : ' · ' + this.variant.title);
      this.q('[data-sticky-price]').textContent = this.choice.price;
      this.setBusy(false);
      this.q('[data-status]').textContent = '';
      const thumbs = this.q('[data-thumbs]');
      thumbs.replaceChildren(...this.choice.images.map((img, index) => {
        const a = document.createElement('a'); a.href = img.large; a.dataset.thumb = index;
        const image = new Image(160,160); image.src = img.thumb; image.alt = img.alt; image.loading = 'lazy'; a.append(image); return a;
      }));
      thumbs.hidden = this.choice.images.length < 2;
      this.showImage(this.choice.images.findIndex(img => img.featured));
      if (writeURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.choice.id);
        url.searchParams.delete('ai_bundle');
        history.replaceState({}, '', url);
      }
    }
    showImage(index) {
      if (index < 0) index = 0;
      const image = this.choice.images[index]; if (!image) return;
      this.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(el => { el.hidden = this.choice.images.length < 2; });
      this.imageIndex = index;
      const hero = this.q('.ai-sb__hero-image');
      hero.srcset = `${image.small} 500w, ${image.src} 1000w`;
      hero.sizes = '(min-width: 990px) 52vw, 100vw'; hero.src = image.src; hero.alt = image.alt;
      this.q('[data-zoom]').href = image.large;
      this.querySelectorAll('[data-thumb]').forEach((el, i) => { if (i === index) el.setAttribute('aria-current','true'); else el.removeAttribute('aria-current'); });
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-add], [data-sticky-add]').forEach(el => {
        el.disabled = busy || !this.choice.available;
        el.textContent = busy ? this.s.adding : this.choice.available ? this.s.add : this.s.soldOut;
      });
      this.querySelectorAll('[data-filters] input').forEach(el => {
        el.disabled = busy;
      });
      this.form.setAttribute('aria-busy', String(busy));
    }
    async addToCart(event) {
      event.preventDefault(); if (this.busy || !this.form.reportValidity()) return;
      this.setBusy(true);
      const status = this.q('[data-status]'); status.textContent = ''; status.dataset.error = 'false';
      const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(this.form);
      const root = window.Shopify?.routes?.root || '/';
      if (cartUI?.getSectionsToRender) {
        body.append('sections',cartUI.getSectionsToRender().map(section => section.id).join(','));
        body.append('sections_url',location.pathname + location.search);
        cartUI.setActiveElement?.(document.activeElement);
      }
      try {
        const response = await fetch(window.routes?.cart_add_url || root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body});
        const result = await response.json();
        if (!response.ok || result.status) {
          status.dataset.error = 'true';
          status.textContent = typeof result.description === 'string' ? result.description : this.s.error;
        } else {
          status.textContent = this.s.added;
          this.q('[data-cart-link]').hidden = false;
          if (cartUI && result.sections && Object.values(result.sections).every(Boolean)) {
            try { cartUI.renderContents(result); cartUI.classList.remove('is-empty'); } catch { this.q('[data-cart-link]').focus(); }
          }
        }
      } catch {
        status.dataset.error = 'true'; status.textContent = this.s.network; this.q('[data-cart-link]').hidden = false;
      } finally { this.setBusy(false); }
    }

  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-bundle-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ai-bundle-product')) {
  customElements.define('ai-bundle-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.s = this.config.strings;
      this.q = selector => this.querySelector(selector);
      this.variant = this.config.variants.find(v => v.id === this.config.initial);
      this.isBundle = false;
      this.form = this.q('form');
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal: this.abort.signal});
      on(this, 'change', event => {
        if (event.target.matches('[data-packages] input')) {
          this.isBundle = event.target.value === 'bundle';
          this.update(true);
        }
        if (event.target.matches('[data-filters] input')) {
          this.variant = this.config.variants.find(v => v.id === Number(event.target.value));
          this.update(true);
        }
      });
      on(this, 'click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) { event.preventDefault(); this.showImage(Number(thumb.dataset.thumb)); }
        const previous = event.target.closest('[data-gallery-prev]');
        if (previous) { event.preventDefault(); const count = this.choice.images.length; if (count > 1) this.showImage((this.imageIndex - 1 + count) % count); return; }
        const next = event.target.closest('[data-gallery-next]');
        if (next) { event.preventDefault(); const count = this.choice.images.length; if (count > 1) this.showImage((this.imageIndex + 1) % count); return; }
        if (event.target.closest('[data-zoom]')) {
          event.preventDefault();
          const img = this.choice.images[this.imageIndex || 0];
          if (img) {
            this.q('[data-large]').src = img.large;
            this.q('[data-large]').alt = img.alt;
            this.q('[data-dialog]').showModal();
          }
        }
        if (event.target.closest('[data-close]') || event.target === this.q('[data-dialog]')) this.q('[data-dialog]').close();
        if (event.target.closest('[data-shipping]')) this.q('[id^="SoundBoxShipping-"]').open = true;
        if (event.target.closest('[data-open-compat]')) { this.q('[data-compat]').open = true; this.q('[data-mic]').focus(); }
      });
      on(this.form, 'submit', event => this.addToCart(event));
      on(window, 'popstate', () => this.readURL());
      this.setupMicrophones(on);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.q('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.observer.observe(this.q('[data-add]'));
      this.readURL();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.initialized = false; }
    readURL() {
      const url = new URL(location.href);
      this.variant = this.config.variants.find(v => String(v.id) === url.searchParams.get('variant')) || this.config.variants.find(v => v.id === this.config.initial);
      this.isBundle = url.searchParams.get('ai_bundle') === '1' && !!this.config.bundle?.available;
      this.querySelectorAll('[data-packages] input').forEach(el => el.checked = el.value === (this.isBundle ? 'bundle' : 'single'));
      this.querySelectorAll('[data-filters] input').forEach(el => el.checked = Number(el.value) === this.variant.id);
      this.update(false);
    }
    update(writeURL) {
      this.choice = this.isBundle ? this.config.bundle : this.variant;
      this.q('[data-price]').textContent = this.choice.price;
      this.q('[data-single-price]').textContent = this.variant.price;
      this.q('[data-color]').textContent = this.variant.title;
      const model = this.config.models[this.variant.title];
      this.config.productHandle = model.handle;
      this.s.compatible = 'listed as compatible with ' + model.name + '.';
      this.q('[data-material]').textContent = model.fit;
      this.q('[data-mic-result]').replaceChildren();
      this.q('[data-mic]').value = '';
      this.querySelectorAll('[data-model-panel]').forEach(el => el.hidden = el.dataset.modelPanel !== this.variant.title);
      const updateStory = () => {
        const image = this.choice.images.find(i => /_(3|4)-ALL/.test(i.src));
        document.querySelectorAll('[data-bundle-story-image]').forEach(el => { if(image){el.src=image.src;el.removeAttribute('srcset');el.alt=model.name+' + Flex Pro and three included filters';} });
      };
      updateStory();
      if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',updateStory,{once:true});
      this.q('[data-filters]').hidden = this.isBundle;
      this.q('[data-bundle-note]').hidden = !this.isBundle;
      this.querySelectorAll('[data-setup-content]').forEach(el => { el.hidden = (el.dataset.setupContent === 'bundle') !== this.isBundle; });
      this.q('[data-variant-id]').value = this.choice.id;
      this.q('[data-included]').textContent = this.config.included.replace('SoundBox model',model.name);
      this.q('[data-sticky-title]').textContent = this.isBundle ? this.s.bundleTitle : model.name + ' + Flex Pro';
      this.q('[data-sticky-price]').textContent = this.choice.price;
      this.setBusy(false);
      this.q('[data-status]').textContent = '';
      const thumbs = this.q('[data-thumbs]');
      thumbs.replaceChildren(...this.choice.images.map((img, index) => {
        const a = document.createElement('a'); a.href = img.large; a.dataset.thumb = index;
        const image = new Image(160,160); image.src = img.thumb; image.alt = img.alt; image.loading = 'lazy'; a.append(image); return a;
      }));
      this.showImage(0);
      if (writeURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.variant.id);
        if (this.isBundle) url.searchParams.set('ai_bundle','1'); else url.searchParams.delete('ai_bundle');
        history.replaceState({}, '', url);
      }
    }
    showImage(index) {
      const image = this.choice.images[index]; if (!image) return;
      this.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(el => { el.hidden = this.choice.images.length < 2; });
      this.imageIndex = index;
      const hero = this.q('.ai-sb__hero-image');
      hero.srcset = `${image.small} 500w, ${image.src} 1000w`;
      hero.sizes = '(min-width: 990px) 52vw, 100vw'; hero.src = image.src; hero.alt = image.alt;
      this.q('[data-zoom]').href = image.large;
      this.querySelectorAll('[data-thumb]').forEach((el, i) => { if (i === index) el.setAttribute('aria-current','true'); else el.removeAttribute('aria-current'); });
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-add], [data-sticky-add]').forEach(el => {
        el.disabled = busy || !this.choice.available;
        el.textContent = busy ? this.s.adding : this.choice.available ? this.s.add : this.s.soldOut;
      });
      this.querySelectorAll('[data-packages] input, [data-filters] input').forEach(el => {
        el.disabled = busy || (el.value === 'bundle' && !this.config.bundle?.available);
      });
      this.form.setAttribute('aria-busy', String(busy));
    }
    async addToCart(event) {
      event.preventDefault(); if (this.busy || !this.form.reportValidity()) return;
      this.setBusy(true);
      const status = this.q('[data-status]'); status.textContent = ''; status.dataset.error = 'false';
      const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(this.form);
      const root = window.Shopify?.routes?.root || '/';
      if (cartUI?.getSectionsToRender) {
        body.append('sections',cartUI.getSectionsToRender().map(section => section.id).join(','));
        body.append('sections_url',location.pathname + location.search);
        cartUI.setActiveElement?.(document.activeElement);
      }
      try {
        const response = await fetch(window.routes?.cart_add_url || root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body});
        const result = await response.json();
        if (!response.ok || result.status) {
          status.dataset.error = 'true';
          status.textContent = typeof result.description === 'string' ? result.description : this.s.error;
        } else {
          status.textContent = this.s.added;
          this.q('[data-cart-link]').hidden = false;
          if (cartUI && result.sections && Object.values(result.sections).every(Boolean)) {
            try { cartUI.renderContents(result); cartUI.classList.remove('is-empty'); } catch { this.q('[data-cart-link]').focus(); }
          }
        }
      } catch {
        status.dataset.error = 'true'; status.textContent = this.s.network; this.q('[data-cart-link]').hidden = false;
      } finally { this.setBusy(false); }
    }
    setupMicrophones(on) {
      const input = this.q('[data-mic]'), list = this.q('[data-mic-list]'), result = this.q('[data-mic-result]');
      const groups = new Map();
      this.config.micGroups.forEach(group => {
        if (!group.handle || !group.models) return;
        group.models.split(',').map(x => x.trim()).filter(Boolean).forEach(model => {
          if (!groups.has(model)) groups.set(model,[]);
          if (!groups.get(model).some(x=>x.handle===group.handle)) groups.get(model).push(group);
        });
      });
      const names = [...groups.keys()].sort((a,b)=>a.localeCompare(b));
      const normalize = text => text.toLowerCase().replace(/[^a-z0-9]/g,'');
      let matches = [], active = -1;
      const close = () => { list.hidden = true; input.setAttribute('aria-expanded','false'); input.removeAttribute('aria-activedescendant'); active = -1; };
      const select = model => {
        input.value = model; close(); result.replaceChildren();
        const current = groups.get(model).some(group=>group.handle===this.config.productHandle);
        const p = document.createElement('p'); p.textContent = model + ' — ' + (current ? this.s.compatible : this.s.alternative); result.append(p);
        groups.get(model).filter(group=>group.handle!==this.config.productHandle).forEach(group=>{
          const a = document.createElement('a'); a.href = group.url; a.textContent = group.handle.replace(/^soundbox/,'SoundBox').replaceAll('-',' '); result.append(a);
        });
        input.focus();
      };
      on(input,'input',()=>{
        result.replaceChildren(); active=-1; input.removeAttribute('aria-activedescendant');
        const query = normalize(input.value);
        if (!query) { close(); return; }
        matches = names.filter(model=>normalize(model).includes(query)).slice(0,30);
        list.replaceChildren(...matches.map((model,index)=>{
          const li = document.createElement('li'); li.id = list.id + '-' + index; li.setAttribute('role','option'); li.setAttribute('aria-selected','false'); li.textContent=model;
          li.addEventListener('mousedown',event=>event.preventDefault()); li.addEventListener('click',()=>select(model)); return li;
        }));
        list.hidden = !matches.length; input.setAttribute('aria-expanded',String(!!matches.length));
        result.textContent = matches.length ? this.s.matches : this.s.noMatch;
      });
      on(input,'keydown',event=>{
        if (event.key==='Escape') { close(); return; }
        if (event.key==='Enter' && active>=0 && !list.hidden) { event.preventDefault(); select(matches[active]); return; }
        if (['ArrowDown','ArrowUp'].includes(event.key) && matches.length && !list.hidden) {
          event.preventDefault(); active = (active + (event.key==='ArrowDown' ? 1 : -1) + matches.length) % matches.length;
          [...list.children].forEach((li,index)=>li.setAttribute('aria-selected',String(index===active)));
          input.setAttribute('aria-activedescendant',list.children[active].id); list.children[active].scrollIntoView({block:'nearest'});
        }
      });
      on(input,'blur',close);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-compatibility"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ai-compatibility')) customElements.define('ai-compatibility',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();const on=(el,e,fn)=>el.addEventListener(e,fn,{signal:this.abort.signal});this.input=this.querySelector('[data-search]');this.list=this.querySelector('[data-suggestions]');this.status=this.querySelector('[data-status]');this.result=this.querySelector('[data-result]');this.empty=this.querySelector('[data-no-match]');this.clear=this.querySelector('[data-clear]');this.map=new Map();JSON.parse(this.querySelector('[data-fit-data]').textContent).forEach(row=>{if(!row.handle||!row.models)return;row.models.split(',').map(s=>s.trim()).filter(Boolean).forEach(name=>{if(!this.map.has(name))this.map.set(name,new Set());this.map.get(name).add(row.handle);});});this.names=[...this.map.keys()].sort((a,b)=>a.localeCompare(b));on(this.input,'input',()=>this.search());on(this.input,'focus',()=>{if(this.input.value&&!this.selected)this.search();});on(this.clear,'click',()=>{this.input.value='';this.search();this.input.focus();});on(this.input,'keydown',e=>{if(e.key==='ArrowDown'&&!this.list.hidden){e.preventDefault();this.list.querySelector('button')?.focus();}if(e.key==='Escape')this.list.hidden=true;});on(this.list,'keydown',e=>{const buttons=[...this.list.querySelectorAll('button')],i=buttons.indexOf(document.activeElement);if(e.key==='ArrowDown'){e.preventDefault();buttons[(i+1)%buttons.length]?.focus();}if(e.key==='ArrowUp'){e.preventDefault();if(i===0)this.input.focus();else buttons[i-1]?.focus();}if(e.key==='Escape'){this.input.focus();this.list.hidden=true;}});on(this.list,'click',e=>{const button=e.target.closest('button');if(button)this.select(button.textContent);});}
 disconnectedCallback(){this.abort?.abort();this.ready=false;}
 normalize(s){return s.toLowerCase().replace(/[^a-z0-9]/g,'');}
 search(){this.selected=false;this.status.classList.remove('visually-hidden');this.list.replaceChildren();this.result.hidden=true;this.empty.hidden=true;this.clear.hidden=!this.input.value;const value=this.normalize(this.input.value);if(!value){this.list.hidden=true;this.status.textContent='';return;}const matches=this.names.filter(n=>this.normalize(n).includes(value));this.list.hidden=!matches.length;this.empty.hidden=!!matches.length;this.status.textContent=matches.length?`${matches.length} microphone match${matches.length===1?'':'es'}. Select your model.`:'No listed microphone matches.';matches.forEach(name=>{const li=document.createElement('li'),b=document.createElement('button');b.type='button';b.textContent=name;li.append(b);this.list.append(li);});}
 select(name){this.selected=true;this.input.value=name;this.clear.hidden=false;this.list.hidden=true;const wrap=this.querySelector('[data-result-cards]');wrap.replaceChildren();for(const handle of this.map.get(name)||[]){const source=[...this.querySelectorAll('.ai-fit__grid [data-model]')].find(el=>el.dataset.model===handle);if(source){const card=source.cloneNode(true);card.removeAttribute('data-model');card.removeAttribute('data-shopify-editor-block');wrap.append(card);}}const found=wrap.children.length>0;this.result.hidden=!found;this.empty.hidden=found;this.querySelector('[data-result-title]').textContent=name;this.status.textContent=found?`${wrap.children.length} SoundBox match${wrap.children.length===1?'':'es'} found for ${name}.`:'Contact support to confirm this microphone’s listed setup.';this.status.classList.toggle('visually-hidden',found);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-flex-pro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ai-flex-pro')) {
  customElements.define('ai-flex-pro', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.s = this.config.strings;
      this.q = selector => this.querySelector(selector);
      this.variant = this.config.variants.find(v => v.id === this.config.initial);
      this.isBundle = false;
      this.form = this.q('form');
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal: this.abort.signal});
      on(this, 'change', event => {
        if (event.target.matches('[data-packages] input')) {
          this.isBundle = event.target.value === 'bundle';
          this.update(true);
        }
        if (event.target.matches('[data-filters] input')) {
          this.variant = this.config.variants.find(v => v.id === Number(event.target.value));
          this.update(true);
        }
      });
      on(this, 'click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) { event.preventDefault(); this.showImage(Number(thumb.dataset.thumb)); }
        const previous = event.target.closest('[data-gallery-prev]');
        if (previous) { event.preventDefault(); const count = this.choice.images.length; if (count > 1) this.showImage((this.imageIndex - 1 + count) % count); return; }
        const next = event.target.closest('[data-gallery-next]');
        if (next) { event.preventDefault(); const count = this.choice.images.length; if (count > 1) this.showImage((this.imageIndex + 1) % count); return; }
        if (event.target.closest('[data-zoom]')) {
          event.preventDefault();
          const img = this.choice.images[this.imageIndex || 0];
          if (img) {
            this.q('[data-large]').src = img.large;
            this.q('[data-large]').alt = img.alt;
            this.q('[data-dialog]').showModal();
          }
        }
        if (event.target.closest('[data-close]') || event.target === this.q('[data-dialog]')) this.q('[data-dialog]').close();
        if (event.target.closest('[data-shipping]')) this.q('[id^="SoundBoxShipping-"]').open = true;
        
      });
      on(this.form, 'submit', event => this.addToCart(event));
      on(window, 'popstate', () => this.readURL());

      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.q('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.observer.observe(this.q('[data-add]'));
      this.readURL();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.initialized = false; }
    readURL() {
      const url = new URL(location.href);
      this.variant = this.config.variants.find(v => String(v.id) === url.searchParams.get('variant')) || this.config.variants.find(v => v.id === this.config.initial);
      this.isBundle = url.searchParams.get('variant') === String(this.config.bundle?.id);
      this.querySelectorAll('[data-packages] input').forEach(el => el.checked = el.value === (this.isBundle ? 'bundle' : 'single'));
      this.querySelectorAll('[data-filters] input').forEach(el => el.checked = Number(el.value) === this.variant.id);
      this.update(false);
    }
    update(writeURL) {
      this.choice = this.isBundle ? this.config.bundle : this.variant;
      this.q('[data-price]').textContent = this.choice.price;
      this.q('[data-single-price]').textContent = this.variant.price;
      const singleImage = this.q('.ai-sb__single-image');
      const selectedImage = this.variant.images[0];
      if (singleImage && selectedImage) {
        singleImage.src = selectedImage.thumb;
        singleImage.removeAttribute('srcset');
        singleImage.alt = this.config.productName + ' with ' + this.variant.title + ' pop filter';
      }
      this.querySelectorAll('[data-packages] input').forEach(el => el.checked = el.value === (this.isBundle ? 'bundle' : 'single'));
      this.querySelectorAll('[data-filters] input').forEach(el => el.checked = Number(el.value) === this.variant.id);
      this.q('[data-color]').textContent = this.variant.title;
      this.q('[data-material]').textContent = this.variant.title.includes('Silver') ? this.s.metal : this.variant.title.includes('Foam') ? this.s.foam : this.s.mesh;
      this.q('[data-filters]').hidden = this.isBundle;
      this.q('[data-bundle-note]').hidden = !this.isBundle;
      this.querySelectorAll('[data-setup-content]').forEach(el => { el.hidden = (el.dataset.setupContent === 'bundle') !== this.isBundle; });
      this.q('[data-variant-id]').value = this.choice.id;
      this.q('[data-included]').textContent = this.isBundle ? this.s.bundle : this.s.single;
      this.q('[data-sticky-title]').textContent = this.isBundle ? this.s.bundleTitle : this.config.productName + ' · ' + this.variant.title;
      this.q('[data-sticky-price]').textContent = this.choice.price;
      this.setBusy(false);
      this.q('[data-status]').textContent = '';
      const thumbs = this.q('[data-thumbs]');
      thumbs.replaceChildren(...this.choice.images.map((img, index) => {
        const a = document.createElement('a'); a.href = img.large; a.dataset.thumb = index;
        const image = new Image(160,160); image.src = img.thumb; image.alt = img.alt; image.loading = 'lazy'; a.append(image); return a;
      }));
      this.showImage(0);
      if (writeURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.choice.id);
        url.searchParams.delete('ai_bundle');
        history.replaceState({}, '', url);
      }
    }
    showImage(index) {
      const image = this.choice.images[index]; if (!image) return;
      this.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(el => { el.hidden = this.choice.images.length < 2; });
      this.imageIndex = index;
      const hero = this.q('.ai-sb__hero-image');
      hero.srcset = `${image.small} 500w, ${image.src} 1000w`;
      hero.sizes = '(min-width: 990px) 52vw, 100vw'; hero.src = image.src; hero.alt = image.alt;
      this.q('[data-zoom]').href = image.large;
      this.querySelectorAll('[data-thumb]').forEach((el, i) => { if (i === index) el.setAttribute('aria-current','true'); else el.removeAttribute('aria-current'); });
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-add], [data-sticky-add]').forEach(el => {
        el.disabled = busy || !this.choice.available;
        el.textContent = busy ? this.s.adding : this.choice.available ? this.s.add : this.s.soldOut;
      });
      this.querySelectorAll('[data-packages] input, [data-filters] input').forEach(el => {
        el.disabled = busy || (el.value === 'bundle' && !this.config.bundle?.available);
      });
      this.form.setAttribute('aria-busy', String(busy));
    }
    async addToCart(event) {
      event.preventDefault(); if (this.busy || !this.form.reportValidity()) return;
      this.setBusy(true);
      const status = this.q('[data-status]'); status.textContent = ''; status.dataset.error = 'false';
      const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(this.form);
      const root = window.Shopify?.routes?.root || '/';
      if (cartUI?.getSectionsToRender) {
        body.append('sections',cartUI.getSectionsToRender().map(section => section.id).join(','));
        body.append('sections_url',location.pathname + location.search);
        cartUI.setActiveElement?.(document.activeElement);
      }
      try {
        const response = await fetch(window.routes?.cart_add_url || root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body});
        const result = await response.json();
        if (!response.ok || result.status) {
          status.dataset.error = 'true';
          status.textContent = typeof result.description === 'string' ? result.description : this.s.error;
        } else {
          status.textContent = this.s.added;
          this.q('[data-cart-link]').hidden = false;
          if (cartUI && result.sections && Object.values(result.sections).every(Boolean)) {
            try { cartUI.renderContents(result); cartUI.classList.remove('is-empty'); } catch { this.q('[data-cart-link]').focus(); }
          }
        }
      } catch {
        status.dataset.error = 'true'; status.textContent = this.s.network; this.q('[data-cart-link]').hidden = false;
      } finally { this.setBusy(false); }
    }

  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-soundbox-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ai-soundbox')) {
  customElements.define('ai-soundbox', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.s = this.config.strings;
      this.q = selector => this.querySelector(selector);
      this.variant = this.config.variants.find(v => v.id === this.config.initial);
      this.isBundle = false;
      this.form = this.q('form');
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal: this.abort.signal});
      on(this, 'change', event => {
        if (event.target.matches('[data-packages] input')) {
          this.isBundle = event.target.value === 'bundle';
          this.update(true);
        }
        if (event.target.matches('[data-filters] input')) {
          this.variant = this.config.variants.find(v => v.id === Number(event.target.value));
          this.update(true);
        }
      });
      on(this, 'click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) { event.preventDefault(); this.showImage(Number(thumb.dataset.thumb)); }
        const previous = event.target.closest('[data-gallery-prev]');
        if (previous) { event.preventDefault(); const count = this.choice.images.length; if (count > 1) this.showImage((this.imageIndex - 1 + count) % count); return; }
        const next = event.target.closest('[data-gallery-next]');
        if (next) { event.preventDefault(); const count = this.choice.images.length; if (count > 1) this.showImage((this.imageIndex + 1) % count); return; }
        if (event.target.closest('[data-zoom]')) {
          event.preventDefault();
          const img = this.choice.images[this.imageIndex || 0];
          if (img) {
            this.q('[data-large]').src = img.large;
            this.q('[data-large]').alt = img.alt;
            this.q('[data-dialog]').showModal();
          }
        }
        if (event.target.closest('[data-close]') || event.target === this.q('[data-dialog]')) this.q('[data-dialog]').close();
        if (event.target.closest('[data-shipping]')) this.q('[id^="SoundBoxShipping-"]').open = true;
        if (event.target.closest('[data-open-compat]')) { this.q('[data-compat]').open = true; this.q('[data-mic]').focus(); }
      });
      on(this.form, 'submit', event => this.addToCart(event));
      on(window, 'popstate', () => this.readURL());
      this.setupMicrophones(on);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.q('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.observer.observe(this.q('[data-add]'));
      this.readURL();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.initialized = false; }
    readURL() {
      const url = new URL(location.href);
      this.variant = this.config.variants.find(v => String(v.id) === url.searchParams.get('variant')) || this.config.variants.find(v => v.id === this.config.initial);
      this.isBundle = url.searchParams.get('ai_bundle') === '1' && !!this.config.bundle?.available;
      this.querySelectorAll('[data-packages] input').forEach(el => el.checked = el.value === (this.isBundle ? 'bundle' : 'single'));
      this.querySelectorAll('[data-filters] input').forEach(el => el.checked = Number(el.value) === this.variant.id);
      this.update(false);
    }
    update(writeURL) {
      this.choice = this.isBundle ? this.config.bundle : this.variant;
      this.q('[data-price]').textContent = this.choice.price;
      this.q('[data-single-price]').textContent = this.variant.price;
      const singleImage = this.q('.ai-sb__single-image');
      const selectedImage = this.variant.images[0];
      if (singleImage && selectedImage) {
        singleImage.src = selectedImage.thumb;
        singleImage.removeAttribute('srcset');
        singleImage.alt = this.config.productName + ' with ' + this.variant.title + ' pop filter';
      }
      this.q('[data-color]').textContent = this.variant.title;
      this.q('[data-material]').textContent = this.variant.title.includes('Silver') ? this.s.metal : this.variant.title.includes('Foam') ? this.s.foam : this.s.mesh;
      this.q('[data-filters]').hidden = this.isBundle;
      this.q('[data-bundle-note]').hidden = !this.isBundle;
      this.querySelectorAll('[data-setup-content]').forEach(el => { el.hidden = (el.dataset.setupContent === 'bundle') !== this.isBundle; });
      this.q('[data-variant-id]').value = this.choice.id;
      this.q('[data-included]').textContent = this.isBundle ? this.s.bundle : this.s.single;
      this.q('[data-sticky-title]').textContent = this.isBundle ? this.s.bundleTitle : this.config.productName + ' · ' + this.variant.title;
      this.q('[data-sticky-price]').textContent = this.choice.price;
      this.setBusy(false);
      this.q('[data-status]').textContent = '';
      const thumbs = this.q('[data-thumbs]');
      thumbs.replaceChildren(...this.choice.images.map((img, index) => {
        const a = document.createElement('a'); a.href = img.large; a.dataset.thumb = index;
        const image = new Image(160,160); image.src = img.thumb; image.alt = img.alt; image.loading = 'lazy'; a.append(image); return a;
      }));
      this.showImage(0);
      if (writeURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.variant.id);
        if (this.isBundle) url.searchParams.set('ai_bundle','1'); else url.searchParams.delete('ai_bundle');
        history.replaceState({}, '', url);
      }
    }
    showImage(index) {
      const image = this.choice.images[index]; if (!image) return;
      this.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(el => { el.hidden = this.choice.images.length < 2; });
      this.imageIndex = index;
      const hero = this.q('.ai-sb__hero-image');
      hero.srcset = `${image.small} 500w, ${image.src} 1000w`;
      hero.sizes = '(min-width: 990px) 52vw, 100vw'; hero.src = image.src; hero.alt = image.alt;
      this.q('[data-zoom]').href = image.large;
      this.querySelectorAll('[data-thumb]').forEach((el, i) => { if (i === index) el.setAttribute('aria-current','true'); else el.removeAttribute('aria-current'); });
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-add], [data-sticky-add]').forEach(el => {
        el.disabled = busy || !this.choice.available;
        el.textContent = busy ? this.s.adding : this.choice.available ? this.s.add : this.s.soldOut;
      });
      this.querySelectorAll('[data-packages] input, [data-filters] input').forEach(el => {
        el.disabled = busy || (el.value === 'bundle' && !this.config.bundle?.available);
      });
      this.form.setAttribute('aria-busy', String(busy));
    }
    async addToCart(event) {
      event.preventDefault(); if (this.busy || !this.form.reportValidity()) return;
      this.setBusy(true);
      const status = this.q('[data-status]'); status.textContent = ''; status.dataset.error = 'false';
      const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(this.form);
      const root = window.Shopify?.routes?.root || '/';
      if (cartUI?.getSectionsToRender) {
        body.append('sections',cartUI.getSectionsToRender().map(section => section.id).join(','));
        body.append('sections_url',location.pathname + location.search);
        cartUI.setActiveElement?.(document.activeElement);
      }
      try {
        const response = await fetch(window.routes?.cart_add_url || root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body});
        const result = await response.json();
        if (!response.ok || result.status) {
          status.dataset.error = 'true';
          status.textContent = typeof result.description === 'string' ? result.description : this.s.error;
        } else {
          status.textContent = this.s.added;
          this.q('[data-cart-link]').hidden = false;
          if (cartUI && result.sections && Object.values(result.sections).every(Boolean)) {
            try { cartUI.renderContents(result); cartUI.classList.remove('is-empty'); } catch { this.q('[data-cart-link]').focus(); }
          }
        }
      } catch {
        status.dataset.error = 'true'; status.textContent = this.s.network; this.q('[data-cart-link]').hidden = false;
      } finally { this.setBusy(false); }
    }
    setupMicrophones(on) {
      const input = this.q('[data-mic]'), list = this.q('[data-mic-list]'), result = this.q('[data-mic-result]');
      const groups = new Map();
      this.config.micGroups.forEach(group => {
        if (!group.handle || !group.models) return;
        group.models.split(',').map(x => x.trim()).filter(Boolean).forEach(model => {
          if (!groups.has(model)) groups.set(model,[]);
          if (!groups.get(model).some(x=>x.handle===group.handle)) groups.get(model).push(group);
        });
      });
      const names = [...groups.keys()].sort((a,b)=>a.localeCompare(b));
      const normalize = text => text.toLowerCase().replace(/[^a-z0-9]/g,'');
      let matches = [], active = -1;
      const close = () => { list.hidden = true; input.setAttribute('aria-expanded','false'); input.removeAttribute('aria-activedescendant'); active = -1; };
      const select = model => {
        input.value = model; close(); result.replaceChildren();
        const current = groups.get(model).some(group=>group.handle===this.config.productHandle);
        const p = document.createElement('p'); p.textContent = model + ' — ' + (current ? this.s.compatible : this.s.alternative); result.append(p);
        groups.get(model).filter(group=>group.handle!==this.config.productHandle).forEach(group=>{
          const a = document.createElement('a'); a.href = group.url; a.textContent = group.handle.replace(/^soundbox/,'SoundBox').replaceAll('-',' '); result.append(a);
        });
        input.focus();
      };
      on(input,'input',()=>{
        result.replaceChildren(); active=-1; input.removeAttribute('aria-activedescendant');
        const query = normalize(input.value);
        if (!query) { close(); return; }
        matches = names.filter(model=>normalize(model).includes(query)).slice(0,30);
        list.replaceChildren(...matches.map((model,index)=>{
          const li = document.createElement('li'); li.id = list.id + '-' + index; li.setAttribute('role','option'); li.setAttribute('aria-selected','false'); li.textContent=model;
          li.addEventListener('mousedown',event=>event.preventDefault()); li.addEventListener('click',()=>select(model)); return li;
        }));
        list.hidden = !matches.length; input.setAttribute('aria-expanded',String(!!matches.length));
        result.textContent = matches.length ? this.s.matches : this.s.noMatch;
      });
      on(input,'keydown',event=>{
        if (event.key==='Escape') { close(); return; }
        if (event.key==='Enter' && active>=0 && !list.hidden) { event.preventDefault(); select(matches[active]); return; }
        if (['ArrowDown','ArrowUp'].includes(event.key) && matches.length && !list.hidden) {
          event.preventDefault(); active = (active + (event.key==='ArrowDown' ? 1 : -1) + matches.length) % matches.length;
          [...list.children].forEach((li,index)=>li.setAttribute('aria-selected',String(index===active)));
          input.setAttribute('aria-activedescendant',list.children[active].id); list.children[active].scrollIntoView({block:'nearest'});
        }
      });
      on(input,'blur',close);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
